































































import { Vue, Component, Prop } from 'vue-property-decorator';

import { objectIsEmpty } from '~/utils/common.js';
import { providerSubType } from '~/utils/explorer.js';

import RespectCard from '~/components/cards/RespectCard.vue';
import XSolid from '~/components/icons/XSolid.vue';
import CartOutline from '~/components/icons/CartOutline.vue';
import EatOutline from '~/components/icons/EatOutline.vue';
import BedSolid from '~/components/icons/BedSolid.vue';
import BinocularSolid from '~/components/icons/BinocularSolid.vue';
import InfoOutline from '~/components/icons/InfoOutline.vue';

@Component({
  components: { RespectCard, XSolid },
})
export default class ProviderCard extends Vue {
  @Prop(Object) provider: Types.Provider;
  @Prop(Boolean) isInLocalisationContext: false;

  /*
    This tricky computed prevents SSR issues when fetching data
    on page load, as this.news can sometimes be null, and sometimes be {}
  */
  get canShow () {
    if (this.isInLocalisationContext && !objectIsEmpty(this.provider)) {
      return true;
    } else if (!this.isInLocalisationContext) {
      return true;
    }
    return false;
  }

  /*
    Classic switcher to return provider icon based on
    type (Vue component in template)
  */
  get providerIcon () {
    switch (this.provider?.type) {
      case 'FOOD': return EatOutline;
      case 'SHOP': return CartOutline;
      case 'HOSTING': return BedSolid;
      case 'TODOTOSEE': return BinocularSolid;
      case 'SERVICE': return InfoOutline;
    }
  }

  /* Computed skeleton handle */
  get providerIsEmpty () {
    return objectIsEmpty(this.provider);
  }

  /* Utils method to return translated provider type */
  get providerSubType () {
    return providerSubType(this.provider?.subtype);
  }

  /* Image fallback if card <img @error> is triggered */
  imageFallback (event: any) {
    event.target.src = "/img/placeholders/provider-placeholder.png";
  }
}
